import { GlobalHelpers } from './core/common/GlobalHelpers';
import { HTTP_INTERCEPTORS, HttpClient, HttpBackend } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';

import './vendor';
import { AuthExpiredInterceptor } from './blocks/interceptor/auth-expired.interceptor';
import { ErrorHandlerInterceptor } from './blocks/interceptor/errorhandler.interceptor';
import { NotificationInterceptor } from './blocks/interceptor/notification.interceptor';
import { FinitoSharedModule } from 'app/shared/shared.module';
import { FinitoCoreModule } from 'app/core/core.module';
import { FinitoAppRoutingModule } from './app-routing.module';
import { FinitoHomeModule } from './home/home.module';
import { FinitoEntityModule } from './entities/entity.module';
// jhipster-needle-angular-add-module-import JHipster will add new module here
import { JhiMainComponent } from './layouts/main/main.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { HasAnyAuthorityDirective } from 'app/shared/auth/has-any-authority.directive';
import { FooterComponent } from './layouts/footer/footer.component';
import { PageRibbonComponent } from './layouts/profiles/page-ribbon.component';
import { ActiveMenuDirective } from './layouts/navbar/active-menu.directive';
import { ErrorComponent } from './layouts/error/error.component';
import { HeroimageComponent } from './layouts/heroimage/heroimage.component';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {NgJhipsterModule} from "app/ng-jhipster/ng-jhipster.module";
import {provideNgxWebstorage, withNgxWebstorageConfig, withSessionStorage  } from "ngx-webstorage";
import {
  faArrowLeft,
  faAsterisk,
  faBan,
  faBars,
  faBell,
  faBook,
  faBuilding,
  faCalendarAlt,
  faCheck,
  faClipboardList,
  faCloud,
  faCog,
  faEye,
  faExclamationTriangle,
  faExclamation,
  faFlag,
  faHdd,
  faHeart,
  faHome,
  faLayerGroup,
  faLink,
  faList,
  faListUl,
  faLock,
  faObjectGroup,
  faPencilAlt,
  faPlus,
  faRoad,
  faSave,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSync,
  faTachometerAlt,
  faTasks,
  faThList,
  faTimes,
  faTrash,
  faTrashAlt,
  faUser,
  faUserPlus,
  faWrench,
  faDownload,
  faDatabase,
  faFileExport,
  faRedoAlt,
  faUnlock,
  faFlagCheckered,
  faMinus,
  faPlay,
  faUndo,
  faUpload,
  faFileDownload,
  faCheckCircle 
} from '@fortawesome/free-solid-svg-icons';
import {NgbDatepickerConfig} from "@ng-bootstrap/ng-bootstrap";
import {FaIconLibrary, FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import moment from 'moment';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

export function HttpLoaderFactory(httpBackend: HttpBackend) {
  const http: HttpClient = new HttpClient(httpBackend);
  return new TranslateHttpLoader(http, '../i18n/', '.json');
}

@NgModule({
  imports: [
    HasAnyAuthorityDirective,
    FontAwesomeModule,
    BrowserModule,
    //NgxWebstorageModule.forRoot({ prefix: 'jhi', separator: '-' }),
    NgJhipsterModule.forRoot({
      // set below to true to make alerts look like toast
      alertAsToast: false,
      alertTimeout: 5000,
      i18nEnabled: true,
      defaultI18nLang: 'en'
    }),
    FinitoSharedModule,
    FinitoCoreModule,
    FinitoHomeModule,
    // jhipster-needle-angular-add-module JHipster will add new module here
    FinitoEntityModule,
    FinitoAppRoutingModule,
    NgxSpinnerModule,
    BrowserAnimationsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    JhiMainComponent,
    NavbarComponent,
    ErrorComponent,
    PageRibbonComponent,
    ActiveMenuDirective,
    FooterComponent,
    HeroimageComponent
  ],
  providers: [
    
   provideNgxWebstorage(
    withNgxWebstorageConfig({
        prefix: 'jhi',
        separator: '-',
        caseSensitive: true
      }),
      withSessionStorage()   // ← THIS FIXES "No provider for SessionStorageService"
    ),
    providePrimeNG({
          theme: {
            preset: Aura,
            options: {
              darkModeSelector: 'none',
            }
          }
        }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true
    },
    GlobalHelpers
  ],
  bootstrap: [JhiMainComponent]
})
export class FinitoAppModule {
  constructor(private dpConfig: NgbDatepickerConfig, library: FaIconLibrary) {
    library.addIcons(faUser);
    library.addIcons(faSort);
    library.addIcons(faSortUp);
    library.addIcons(faSortDown);
    library.addIcons(faSync);
    library.addIcons(faEye);
    library.addIcons(faBan);
    library.addIcons(faTimes);
    library.addIcons(faArrowLeft);
    library.addIcons(faSave);
    library.addIcons(faPlus);
    library.addIcons(faPencilAlt);
    library.addIcons(faBars);
    library.addIcons(faHome);
    library.addIcons(faThList);
    library.addIcons(faUserPlus);
    library.addIcons(faRoad);
    library.addIcons(faTachometerAlt);
    library.addIcons(faHeart);
    library.addIcons(faList);
    library.addIcons(faBell);
    library.addIcons(faTasks);
    library.addIcons(faBook);
    library.addIcons(faHdd);
    library.addIcons(faFlag);
    library.addIcons(faWrench);
    library.addIcons(faLock);
    library.addIcons(faCloud);
    library.addIcons(faSignOutAlt);
    library.addIcons(faSignInAlt);
    library.addIcons(faCalendarAlt);
    library.addIcons(faSearch);
    library.addIcons(faTrashAlt);
    library.addIcons(faAsterisk);
    library.addIcons(faTrash);
    library.addIcons(faBuilding);
    library.addIcons(faLink);
    library.addIcons(faCheck);
    library.addIcons(faListUl);
    library.addIcons(faLayerGroup);
    library.addIcons(faObjectGroup);
    library.addIcons(faClipboardList);
    library.addIcons(faCog);
    library.addIcons(faCalendarAlt);
    library.addIcons(faDownload);
    library.addIcons(faExclamationTriangle);
    library.addIcons(faExclamation);
    library.addIcons(faDatabase);
    library.addIcons(faFileExport);
    library.addIcons(faRedoAlt);
    library.addIcons(faUnlock);
    library.addIcons(faFlagCheckered);
    library.addIcons(faMinus);
    library.addIcons(faPlay);
    library.addIcons(faUndo);
    library.addIcons(faUpload);
    library.addIcons(faFileDownload);
    library.addIcons(faCheckCircle);
    this.dpConfig.minDate = { year: moment().year() - 100, month: 1, day: 1 };
  }
}
